import { render, staticRenderFns } from "./system_role_edit.vue?vue&type=template&id=8cd1690e&scoped=true"
import script from "./system_role_edit.vue?vue&type=script&lang=js"
export * from "./system_role_edit.vue?vue&type=script&lang=js"
import style0 from "./system_role_edit.vue?vue&type=style&index=0&id=8cd1690e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cd1690e",
  null
  
)

export default component.exports